import r from"styled-components";import{theme as o}from"../../../../../theme.js";const i=r.div`
  display: flex;
  flex-direction: column;
  gap: ${o.spacing}px;
  > label {
    display: flex;
    align-items: center;
    gap: ${o.spacing}px;
    cursor: pointer;
    width: fit-content;
    > svg {
      width: 20px;
      height: 20px;
      > g, 
      path {
        fill: ${o.colors.gray[300]};
      }
    }
    &.active {
      > svg {
        > g, 
        path {
          fill: ${o.colors.primary[500]};
        }
      }
      > span {
        color: ${o.colors.gray[900]};
        font-weight: 700;
      }
    }
    > span {
      font-size: 14px;
      color: ${o.colors.gray[300]};
    }
  }
`;export{i as Wrapper};
